import SettingFrame from "../../../../components/@settings/SettingFrame";
import ListWallets from "../../../../components/@wallets/wallets/ListWallets";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function WalletsPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <ListWallets
                routeType={routeType}
            />
        </SettingFrame>
    )
}       